"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenerVersion = exports.Opener = exports.ForceVariations = void 0;
/**
 * @private
 */
var ForceVariations;
(function (ForceVariations) {
    ForceVariations[ForceVariations["No"] = 0] = "No";
    ForceVariations[ForceVariations["ForceOne"] = 1] = "ForceOne";
    ForceVariations[ForceVariations["ForceMany"] = 2] = "ForceMany";
})(ForceVariations = exports.ForceVariations || (exports.ForceVariations = {}));
var Opener;
(function (Opener) {
    Opener["MediaManager"] = "media-manager";
    Opener["Playground"] = "playground";
    Opener["MediaEditorPanel"] = "media_editor_panel";
})(Opener = exports.Opener || (exports.Opener = {}));
var OpenerVersion;
(function (OpenerVersion) {
    OpenerVersion["V1"] = "v1";
    OpenerVersion["V2"] = "v2";
})(OpenerVersion = exports.OpenerVersion || (exports.OpenerVersion = {}));
//# sourceMappingURL=GenericInputParams.js.map